import { BellPlusIcon } from './BellPlusIcon';

/**
 * author: Simran
 * id FC07FF46-2FD1-4E4E-8D35-BADDEEB5F531
 * name bell-plus
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/bell-plus.svg
 * tags
 * - Notification 
 */
export const BellAddIcon = BellPlusIcon;
export default BellAddIcon